export default {
  data: () => ({
    videos: {
      current: {
        en: {
          url: "https://s3.monitait.com/instruction-videos/Current%20Shift.mp4"
        }
      },
      history: {
        en: {
          url: "https://s3.monitait.com/instruction-videos/History.mp4"
        }
      },
      "history-detail": {

      },
      "chart-tv": {

      },
      products: {

      },
      shift: {

      },
      timeline: {

      },
      watchers: {

      },
      recources: {

      },
      production: {

      },
      "production-detail": {

      },
      "ticket-list": {

      },
      groups: {

      },
      operators: {

      },
      operator: {

      },
      "operator-operation-detail": {

      },
      "operator-history": {

      },
      "report-request": {

      },
      "supplier-dashboard": {

      },
      "supplier-detail": {

      }
    }
  })
}